import React, { useCallback, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faChevronLeft,
  faSpinner,
  faRedo as iconRefresh,
} from '@fortawesome/free-solid-svg-icons';

import Title from '../../../components/Title';
import { auth } from '../../../helpers/firebase';
import { toastError } from '../../../helpers/toastHelpers';
import { titleHelper } from '../../../helpers/titleHelper';
import { getDraftYears } from '../../../data/getDraftDetails';
import '../admin.css';

const DraftAdminDocumentSelector = () => {
  const [draftYears, setDraftYears] = useState([]);
  const [selectedDraftYear, setSelectedDraftYear] = useState('');
  const [loading, setLoading] = useState(true);

  const loadDraftYears = useCallback(async () => {
    setLoading(true);
    const result = await getDraftYears();

    if (result.error) {
      toastError(result.message);
      setDraftYears([]);
      setSelectedDraftYear('');
    } else {
      setDraftYears(result.draftYears);
      setSelectedDraftYear(result.draftYears[0] || '');
    }

    setLoading(false);
  }, []);

  useEffect(() => {
    titleHelper('Draft Documents');

    if (auth.currentUser) {
      loadDraftYears();
    }
  }, [loadDraftYears]);

  return (
    <div id="psf-draft-admin-container" className="psf-container">
      <div className="container">
        <Title text="Draft Documents" />

        <div className="d-flex justify-content-between align-items-center mb-3">
          <Link to="/draft/admin" className="btn btn-sm btn-outline-light px-3 shadow">
            <FontAwesomeIcon icon={faChevronLeft} className="mr-2" />
            Back To Draft Admin
          </Link>

          <button
            type="button"
            className="btn btn-sm btn-success px-3 shadow"
            onClick={loadDraftYears}
          >
            <FontAwesomeIcon icon={iconRefresh} />
          </button>
        </div>
      </div>

      <div className="container-fluid shadow row-background p-4">
        {loading ? (
          <div className="text-center">
            <FontAwesomeIcon icon={faSpinner} size="3x" spin className="text-yellow" />
          </div>
        ) : (
          <div className="row">
            <div className="col-12 col-md-8 col-lg-6">
              <label className="label text-yellow-light" htmlFor="draft-document-select">Draft Years</label>
              <select
                id="draft-document-select"
                className="form-control"
                value={selectedDraftYear}
                onChange={(event) => setSelectedDraftYear(event.target.value)}
              >
                {draftYears.length > 0 ? draftYears.map((draftYear) => (
                  <option key={draftYear} value={draftYear}>{draftYear}</option>
                )) : <option value="">No draft documents found</option>}
              </select>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default DraftAdminDocumentSelector;